import flag_ad from "../../images/countryFlags/ad.svg";
import flag_ae from "../../images/countryFlags/ae.svg";
import flag_af from "../../images/countryFlags/af.svg";
import flag_ag from "../../images/countryFlags/ag.svg";
import flag_ai from "../../images/countryFlags/ai.svg";
import flag_al from "../../images/countryFlags/al.svg";
import flag_am from "../../images/countryFlags/am.svg";
import flag_ao from "../../images/countryFlags/ao.svg";
import flag_aq from "../../images/countryFlags/aq.svg";
import flag_ar from "../../images/countryFlags/ar.svg";
import flag_as from "../../images/countryFlags/as.svg";
import flag_at from "../../images/countryFlags/at.svg";
import flag_au from "../../images/countryFlags/au.svg";
import flag_aw from "../../images/countryFlags/aw.svg";
import flag_ax from "../../images/countryFlags/ax.svg";
import flag_az from "../../images/countryFlags/az.svg";
import flag_ba from "../../images/countryFlags/ba.svg";
import flag_bb from "../../images/countryFlags/bb.svg";
import flag_bd from "../../images/countryFlags/bd.svg";
import flag_be from "../../images/countryFlags/be.svg";
import flag_bf from "../../images/countryFlags/bf.svg";
import flag_bg from "../../images/countryFlags/bg.svg";
import flag_bh from "../../images/countryFlags/bh.svg";
import flag_bi from "../../images/countryFlags/bi.svg";
import flag_bj from "../../images/countryFlags/bj.svg";
import flag_bl from "../../images/countryFlags/bl.svg";
import flag_bm from "../../images/countryFlags/bm.svg";
import flag_bn from "../../images/countryFlags/bn.svg";
import flag_bo from "../../images/countryFlags/bo.svg";
import flag_bq from "../../images/countryFlags/bq.svg";
import flag_br from "../../images/countryFlags/br.svg";
import flag_bs from "../../images/countryFlags/bs.svg";
import flag_bt from "../../images/countryFlags/bt.svg";
import flag_bv from "../../images/countryFlags/bv.svg";
import flag_bw from "../../images/countryFlags/bw.svg";
import flag_by from "../../images/countryFlags/by.svg";
import flag_bz from "../../images/countryFlags/bz.svg";
import flag_ca from "../../images/countryFlags/ca.svg";
import flag_cc from "../../images/countryFlags/cc.svg";
import flag_cd from "../../images/countryFlags/cd.svg";
import flag_cf from "../../images/countryFlags/cf.svg";
import flag_cg from "../../images/countryFlags/cg.svg";
import flag_ch from "../../images/countryFlags/ch.svg";
import flag_ci from "../../images/countryFlags/ci.svg";
import flag_ck from "../../images/countryFlags/ck.svg";
import flag_cl from "../../images/countryFlags/cl.svg";
import flag_cm from "../../images/countryFlags/cm.svg";
import flag_cn from "../../images/countryFlags/cn.svg";
import flag_co from "../../images/countryFlags/co.svg";
import flag_cr from "../../images/countryFlags/cr.svg";
import flag_cu from "../../images/countryFlags/cu.svg";
import flag_cv from "../../images/countryFlags/cv.svg";
import flag_cw from "../../images/countryFlags/cw.svg";
import flag_cx from "../../images/countryFlags/cx.svg";
import flag_cy from "../../images/countryFlags/cy.svg";
import flag_cz from "../../images/countryFlags/cz.svg";
import flag_de from "../../images/countryFlags/de.svg";
import flag_dj from "../../images/countryFlags/dj.svg";
import flag_dk from "../../images/countryFlags/dk.svg";
import flag_dm from "../../images/countryFlags/dm.svg";
import flag_do from "../../images/countryFlags/do.svg";
import flag_dz from "../../images/countryFlags/dz.svg";
import flag_ec from "../../images/countryFlags/ec.svg";
import flag_ee from "../../images/countryFlags/ee.svg";
import flag_eg from "../../images/countryFlags/eg.svg";
import flag_eh from "../../images/countryFlags/eh.svg";
import flag_er from "../../images/countryFlags/er.svg";
import flag_es from "../../images/countryFlags/es.svg";
import flag_et from "../../images/countryFlags/et.svg";
import flag_eu from "../../images/countryFlags/eu.svg";
import flag_fi from "../../images/countryFlags/fi.svg";
import flag_fj from "../../images/countryFlags/fj.svg";
import flag_fk from "../../images/countryFlags/fk.svg";
import flag_fm from "../../images/countryFlags/fm.svg";
import flag_fo from "../../images/countryFlags/fo.svg";
import flag_fr from "../../images/countryFlags/fr.svg";
import flag_ga from "../../images/countryFlags/ga.svg";
import flag_gb from "../../images/countryFlags/gb.svg";
import flag_gd from "../../images/countryFlags/gd.svg";
import flag_ge from "../../images/countryFlags/ge.svg";
import flag_gf from "../../images/countryFlags/gf.svg";
import flag_gg from "../../images/countryFlags/gg.svg";
import flag_gh from "../../images/countryFlags/gh.svg";
import flag_gi from "../../images/countryFlags/gi.svg";
import flag_gl from "../../images/countryFlags/gl.svg";
import flag_gm from "../../images/countryFlags/gm.svg";
import flag_gn from "../../images/countryFlags/gn.svg";
import flag_gp from "../../images/countryFlags/gp.svg";
import flag_gq from "../../images/countryFlags/gq.svg";
import flag_gr from "../../images/countryFlags/gr.svg";
import flag_gs from "../../images/countryFlags/gs.svg";
import flag_gt from "../../images/countryFlags/gt.svg";
import flag_gu from "../../images/countryFlags/gu.svg";
import flag_gw from "../../images/countryFlags/gw.svg";
import flag_gy from "../../images/countryFlags/gy.svg";
import flag_hk from "../../images/countryFlags/hk.svg";
import flag_hm from "../../images/countryFlags/hm.svg";
import flag_hn from "../../images/countryFlags/hn.svg";
import flag_hr from "../../images/countryFlags/hr.svg";
import flag_ht from "../../images/countryFlags/ht.svg";
import flag_hu from "../../images/countryFlags/hu.svg";
import flag_id from "../../images/countryFlags/id.svg";
import flag_ie from "../../images/countryFlags/ie.svg";
import flag_il from "../../images/countryFlags/il.svg";
import flag_im from "../../images/countryFlags/im.svg";
import flag_in from "../../images/countryFlags/in.svg";
import flag_io from "../../images/countryFlags/io.svg";
import flag_iq from "../../images/countryFlags/iq.svg";
import flag_ir from "../../images/countryFlags/ir.svg";
import flag_is from "../../images/countryFlags/is.svg";
import flag_it from "../../images/countryFlags/it.svg";
import flag_je from "../../images/countryFlags/je.svg";
import flag_jm from "../../images/countryFlags/jm.svg";
import flag_jo from "../../images/countryFlags/jo.svg";
import flag_jp from "../../images/countryFlags/jp.svg";
import flag_ke from "../../images/countryFlags/ke.svg";
import flag_kg from "../../images/countryFlags/kg.svg";
import flag_kh from "../../images/countryFlags/kh.svg";
import flag_ki from "../../images/countryFlags/ki.svg";
import flag_km from "../../images/countryFlags/km.svg";
import flag_kn from "../../images/countryFlags/kn.svg";
import flag_kp from "../../images/countryFlags/kp.svg";
import flag_kr from "../../images/countryFlags/kr.svg";
import flag_kw from "../../images/countryFlags/kw.svg";
import flag_ky from "../../images/countryFlags/ky.svg";
import flag_kz from "../../images/countryFlags/kz.svg";
import flag_la from "../../images/countryFlags/la.svg";
import flag_lb from "../../images/countryFlags/lb.svg";
import flag_lc from "../../images/countryFlags/lc.svg";
import flag_li from "../../images/countryFlags/li.svg";
import flag_lk from "../../images/countryFlags/lk.svg";
import flag_lr from "../../images/countryFlags/lr.svg";
import flag_ls from "../../images/countryFlags/ls.svg";
import flag_lt from "../../images/countryFlags/lt.svg";
import flag_lu from "../../images/countryFlags/lu.svg";
import flag_lv from "../../images/countryFlags/lv.svg";
import flag_ly from "../../images/countryFlags/ly.svg";
import flag_ma from "../../images/countryFlags/ma.svg";
import flag_mc from "../../images/countryFlags/mc.svg";
import flag_md from "../../images/countryFlags/md.svg";
import flag_me from "../../images/countryFlags/me.svg";
import flag_mf from "../../images/countryFlags/mf.svg";
import flag_mg from "../../images/countryFlags/mg.svg";
import flag_mh from "../../images/countryFlags/mh.svg";
import flag_mk from "../../images/countryFlags/mk.svg";
import flag_ml from "../../images/countryFlags/ml.svg";
import flag_mm from "../../images/countryFlags/mm.svg";
import flag_mn from "../../images/countryFlags/mn.svg";
import flag_mo from "../../images/countryFlags/mo.svg";
import flag_mp from "../../images/countryFlags/mp.svg";
import flag_mq from "../../images/countryFlags/mq.svg";
import flag_mr from "../../images/countryFlags/mr.svg";
import flag_ms from "../../images/countryFlags/ms.svg";
import flag_mt from "../../images/countryFlags/mt.svg";
import flag_mu from "../../images/countryFlags/mu.svg";
import flag_mv from "../../images/countryFlags/mv.svg";
import flag_mw from "../../images/countryFlags/mw.svg";
import flag_mx from "../../images/countryFlags/mx.svg";
import flag_my from "../../images/countryFlags/my.svg";
import flag_mz from "../../images/countryFlags/mz.svg";
import flag_na from "../../images/countryFlags/na.svg";
import flag_nc from "../../images/countryFlags/nc.svg";
import flag_ne from "../../images/countryFlags/ne.svg";
import flag_nf from "../../images/countryFlags/nf.svg";
import flag_ng from "../../images/countryFlags/ng.svg";
import flag_ni from "../../images/countryFlags/ni.svg";
import flag_nl from "../../images/countryFlags/nl.svg";
import flag_no from "../../images/countryFlags/no.svg";
import flag_np from "../../images/countryFlags/np.svg";
import flag_nr from "../../images/countryFlags/nr.svg";
import flag_nu from "../../images/countryFlags/nu.svg";
import flag_nz from "../../images/countryFlags/nz.svg";
import flag_om from "../../images/countryFlags/om.svg";
import flag_pa from "../../images/countryFlags/pa.svg";
import flag_pe from "../../images/countryFlags/pe.svg";
import flag_pf from "../../images/countryFlags/pf.svg";
import flag_pg from "../../images/countryFlags/pg.svg";
import flag_ph from "../../images/countryFlags/ph.svg";
import flag_pk from "../../images/countryFlags/pk.svg";
import flag_pl from "../../images/countryFlags/pl.svg";
import flag_pm from "../../images/countryFlags/pm.svg";
import flag_pn from "../../images/countryFlags/pn.svg";
import flag_pr from "../../images/countryFlags/pr.svg";
import flag_ps from "../../images/countryFlags/ps.svg";
import flag_pt from "../../images/countryFlags/pt.svg";
import flag_pw from "../../images/countryFlags/pw.svg";
import flag_py from "../../images/countryFlags/py.svg";
import flag_qa from "../../images/countryFlags/qa.svg";
import flag_re from "../../images/countryFlags/re.svg";
import flag_ro from "../../images/countryFlags/ro.svg";
import flag_rs from "../../images/countryFlags/rs.svg";
import flag_ru from "../../images/countryFlags/ru.svg";
import flag_rw from "../../images/countryFlags/rw.svg";
import flag_sa from "../../images/countryFlags/sa.svg";
import flag_sb from "../../images/countryFlags/sb.svg";
import flag_sc from "../../images/countryFlags/sc.svg";
import flag_sd from "../../images/countryFlags/sd.svg";
import flag_se from "../../images/countryFlags/se.svg";
import flag_sg from "../../images/countryFlags/sg.svg";
import flag_sh from "../../images/countryFlags/sh.svg";
import flag_si from "../../images/countryFlags/si.svg";
import flag_sj from "../../images/countryFlags/sj.svg";
import flag_sk from "../../images/countryFlags/sk.svg";
import flag_sl from "../../images/countryFlags/sl.svg";
import flag_sm from "../../images/countryFlags/sm.svg";
import flag_sn from "../../images/countryFlags/sn.svg";
import flag_so from "../../images/countryFlags/so.svg";
import flag_sr from "../../images/countryFlags/sr.svg";
import flag_ss from "../../images/countryFlags/ss.svg";
import flag_st from "../../images/countryFlags/st.svg";
import flag_sv from "../../images/countryFlags/sv.svg";
import flag_sx from "../../images/countryFlags/sx.svg";
import flag_sy from "../../images/countryFlags/sy.svg";
import flag_sz from "../../images/countryFlags/sz.svg";
import flag_tc from "../../images/countryFlags/tc.svg";
import flag_td from "../../images/countryFlags/td.svg";
import flag_tf from "../../images/countryFlags/tf.svg";
import flag_tg from "../../images/countryFlags/tg.svg";
import flag_th from "../../images/countryFlags/th.svg";
import flag_tj from "../../images/countryFlags/tj.svg";
import flag_tk from "../../images/countryFlags/tk.svg";
import flag_tl from "../../images/countryFlags/tl.svg";
import flag_tm from "../../images/countryFlags/tm.svg";
import flag_tn from "../../images/countryFlags/tn.svg";
import flag_to from "../../images/countryFlags/to.svg";
import flag_tr from "../../images/countryFlags/tr.svg";
import flag_tt from "../../images/countryFlags/tt.svg";
import flag_tv from "../../images/countryFlags/tv.svg";
import flag_tw from "../../images/countryFlags/tw.svg";
import flag_tz from "../../images/countryFlags/tz.svg";
import flag_ua from "../../images/countryFlags/ua.svg";
import flag_ug from "../../images/countryFlags/ug.svg";
import flag_um from "../../images/countryFlags/um.svg";
import flag_us from "../../images/countryFlags/us.svg";
import flag_uy from "../../images/countryFlags/uy.svg";
import flag_uz from "../../images/countryFlags/uz.svg";
import flag_va from "../../images/countryFlags/va.svg";
import flag_vc from "../../images/countryFlags/vc.svg";
import flag_ve from "../../images/countryFlags/ve.svg";
import flag_vg from "../../images/countryFlags/vg.svg";
import flag_vi from "../../images/countryFlags/vi.svg";
import flag_vn from "../../images/countryFlags/vn.svg";
import flag_vu from "../../images/countryFlags/vu.svg";
import flag_wf from "../../images/countryFlags/wf.svg";
import flag_ws from "../../images/countryFlags/ws.svg";
import flag_xk from "../../images/countryFlags/xk.svg";
import flag_ye from "../../images/countryFlags/ye.svg";
import flag_yt from "../../images/countryFlags/yt.svg";
import flag_za from "../../images/countryFlags/za.svg";
import flag_zm from "../../images/countryFlags/zm.svg";
import flag_zw from "../../images/countryFlags/zw.svg";

export type TMGFlagCountry = {
  code?: string;
  country: string;
  flag: string;
  iso2: string;
  iso3: string;
};

export const mgFlagsCountries = {
  ad: { country: "Andorra", code: "+376", iso2: "AD", iso3: "AND", flag: flag_ad },
  ae: { country: "Emirados Árabes Unidos", code: "+971", iso2: "AE", iso3: "ARE", flag: flag_ae },
  af: { country: "Afeganistão", code: "+93", iso2: "AF", iso3: "AFG", flag: flag_af },
  ag: { country: "Antígua e Barbuda", code: "+1268", iso2: "AG", iso3: "ATG", flag: flag_ag },
  ai: { country: "Anguilla", code: "+1264", iso2: "AI", iso3: "AIA", flag: flag_ai },
  al: { country: "Albânia", code: "+355", iso2: "AL", iso3: "ALB", flag: flag_al },
  am: { country: "Arménia", code: "+374", iso2: "AM", iso3: "ARM", flag: flag_am },
  ao: { country: "Angola", code: "+244", iso2: "AO", iso3: "AGO", flag: flag_ao },
  aq: { country: "Antártida", code: "+672", iso2: "AQ", iso3: "ATA", flag: flag_aq },
  ar: { country: "Argentina", code: "+54", iso2: "AR", iso3: "ARG", flag: flag_ar },
  as: { country: "Samoa", code: "+1684", iso2: "AS", iso3: "ASM", flag: flag_as },
  at: { country: "Áustria", code: "+43", iso2: "AT", iso3: "AUT", flag: flag_at },
  au: { country: "Austrália", code: "+61", iso2: "AU", iso3: "AUS", flag: flag_au },
  aw: { country: "Aruba", code: "+297", iso2: "AW", iso3: "ABW", flag: flag_aw },
  ax: { country: "Aland", code: "+358", iso2: "AX", iso3: "ALA", flag: flag_ax },
  az: { country: "Azerbaijão", code: "+994", iso2: "AZ", iso3: "AZE", flag: flag_az },
  ba: { country: "Bósnia", code: "+387", iso2: "BA", iso3: "BIH", flag: flag_ba },
  bb: { country: "Barbados", code: "+1246", iso2: "BB", iso3: "BRB", flag: flag_bb },
  bd: { country: "Bangladesh", code: "+880", iso2: "BD", iso3: "BGD", flag: flag_bd },
  be: { country: "Bélgica", code: "+32", iso2: "BE", iso3: "BEL", flag: flag_be },
  bf: { country: "Burquina Faso", code: "+226", iso2: "BF", iso3: "BFA", flag: flag_bf },
  bg: { country: "Bulgária", code: "+359", iso2: "BG", iso3: "BGR", flag: flag_bg },
  bh: { country: "Bahrein", code: "+973", iso2: "BH", iso3: "BHR", flag: flag_bh },
  bi: { country: "Burundi", code: "+257", iso2: "BI", iso3: "BDI", flag: flag_bi },
  bj: { country: "Benin", code: "+229", iso2: "BJ", iso3: "BEN", flag: flag_bj },
  bl: { country: "Saint Barth", code: "+590", iso2: "BL", iso3: "BLM", flag: flag_bl },
  bm: { country: "Bermudas", code: "+1441", iso2: "BM", iso3: "BMU", flag: flag_bm },
  bn: { country: "Brunei", code: "+673", iso2: "BN", iso3: "BRN", flag: flag_bn },
  bo: { country: "Bolivia", code: "+591", iso2: "BO", iso3: "BOL", flag: flag_bo },
  bq: { country: "Bonaire", code: "+599", iso2: "BQ", iso3: "BES", flag: flag_bq },
  br: { country: "Brasil", code: "+55", iso2: "BR", iso3: "BRA", flag: flag_br },
  bs: { country: "Bahamas", code: "+1242", iso2: "BS", iso3: "BHS", flag: flag_bs },
  bt: { country: "Butão", code: "+975", iso2: "BT", iso3: "BTN", flag: flag_bt },
  bv: { country: "Bouvet", code: "+47", iso2: "BV", iso3: "BVT", flag: flag_bv },
  bw: { country: "Botswana", code: "+267", iso2: "BW", iso3: "BWA", flag: flag_bw },
  by: { country: "Bielorrússia", code: "+375", iso2: "BY", iso3: "BLR", flag: flag_by },
  bz: { country: "Belize", code: "+501", iso2: "BZ", iso3: "BLZ", flag: flag_bz },
  ca: { country: "Canadá", code: "+001", iso2: "CA", iso3: "CAN", flag: flag_ca },
  cc: { country: "Cocos", code: "+61", iso2: "CC", iso3: "CCK", flag: flag_cc },
  cd: {
    country: "República Democrática do Congo",
    code: "+243",
    iso2: "CD",
    iso3: "COD",
    flag: flag_cd,
  },
  cf: {
    country: "República Centro-Africana",
    code: "+236",
    iso2: "CF",
    iso3: "CAF",
    flag: flag_cf,
  },
  cg: { country: "República do Congo", code: "+242", iso2: "CG", iso3: "COG", flag: flag_cg },
  ch: { country: "Suíça", code: "+41", iso2: "CH", iso3: "CHE", flag: flag_ch },
  ci: { country: "Costa do Marfim", code: "+225", iso2: "CI", iso3: "CIV", flag: flag_ci },
  ck: { country: "Ilhas Cook", code: "+682", iso2: "CK", iso3: "COK", flag: flag_ck },
  cl: { country: "Chile", code: "+56", iso2: "CL", iso3: "CHL", flag: flag_cl },
  cm: { country: "Camarões", code: "+237", iso2: "CM", iso3: "CMR", flag: flag_cm },
  cn: { country: "China", code: "+86", iso2: "CN", iso3: "CHN", flag: flag_cn },
  co: { country: "Colômbia", code: "+57", iso2: "CO", iso3: "COL", flag: flag_co },
  cr: { country: "Costa Rica", code: "+506", iso2: "CR", iso3: "CRI", flag: flag_cr },
  cu: { country: "Cuba", code: "+53", iso2: "CU", iso3: "CUB", flag: flag_cu },
  cv: { country: "Cabo Verde", code: "+238", iso2: "CV", iso3: "CPV", flag: flag_cv },
  cw: { country: "Curaçau", code: "+599", iso2: "CW", iso3: "CUW", flag: flag_cw },
  cx: { country: "Ilha do Natal", code: "+61", iso2: "CX", iso3: "CXR", flag: flag_cx },
  cy: { country: "Chipre", code: "+357", iso2: "CY", iso3: "CYP", flag: flag_cy },
  cz: { country: "República Checa", code: "+420", iso2: "CZ", iso3: "CZE", flag: flag_cz },
  de: { country: "Alemanha", code: "+49", iso2: "DE", iso3: "DEU", flag: flag_de },
  dj: { country: "Djibouti", code: "+253", iso2: "DJ", iso3: "DJI", flag: flag_dj },
  dk: { country: "Dinamarca", code: "+45", iso2: "DK", iso3: "DNK", flag: flag_dk },
  dm: { country: "Dominica", code: "+1767", iso2: "DM", iso3: "DMA", flag: flag_dm },
  do: { country: "República Dominicana", code: "+1809", iso2: "DO", iso3: "DOM", flag: flag_do },
  dz: { country: "Argélia", code: "+213", iso2: "DZ", iso3: "DZA", flag: flag_dz },
  ec: { country: "Equador", code: "+593", iso2: "EC", iso3: "ECU", flag: flag_ec },
  ee: { country: "Estónia", code: "+372", iso2: "EE", iso3: "EST", flag: flag_ee },
  eg: { country: "Egito", code: "+20", iso2: "EG", iso3: "EGY", flag: flag_eg },
  eh: { country: "Saara Ocidental", code: "+212", iso2: "EH", iso3: "ESH", flag: flag_eh },
  er: { country: "Eritreia", code: "+291", iso2: "ER", iso3: "ERI", flag: flag_er },
  es: { country: "Espanha", code: "+34", iso2: "ES", iso3: "ESP", flag: flag_es },
  et: { country: "Etiópia", code: "+251", iso2: "ET", iso3: "ETH", flag: flag_et },
  eu: { country: "União Europeia", iso2: "EU", iso3: "EUU", flag: flag_eu },
  fi: { country: "Finlândia", code: "+358", iso2: "FI", iso3: "FIN", flag: flag_fi },
  fj: { country: "Fiji", code: "+679", iso2: "FJ", iso3: "FJI", flag: flag_fj },
  fk: { country: "Ilhas Malvinas", code: "+500", iso2: "FK", iso3: "FLK", flag: flag_fk },
  fm: {
    country: "Estados Federados da Micronésia",
    code: "+691",
    iso2: "FM",
    iso3: "FSM",
    flag: flag_fm,
  },
  fo: { country: "Ilhas Faroé", code: "+298", iso2: "FO", iso3: "FRO", flag: flag_fo },
  fr: { country: "França", code: "+33", iso2: "FR", iso3: "FRA", flag: flag_fr },
  ga: { country: "Gabão", code: "+241", iso2: "GA", iso3: "GAB", flag: flag_ga },
  gb: { country: "Reino Unido", code: "+44", iso2: "GB", iso3: "GBR", flag: flag_gb },
  gd: { country: "Granada", code: "+1473", iso2: "GD", iso3: "GRD", flag: flag_gd },
  ge: { country: "Geórgia", code: "+995", iso2: "GE", iso3: "GEO", flag: flag_ge },
  gf: { country: "Guiana Francesa", code: "+594", iso2: "GF", iso3: "GUF", flag: flag_gf },
  gg: { country: "Guernsey", code: "+441481", iso2: "GG", iso3: "GGY", flag: flag_gg },
  gh: { country: "Gana", code: "+233", iso2: "GH", iso3: "GHA", flag: flag_gh },
  gi: { country: "Gibraltar", code: "+350", iso2: "GI", iso3: "GIB", flag: flag_gi },
  gl: { country: "Gronelândia", code: "+299", iso2: "GL", iso3: "GRL", flag: flag_gl },
  gm: { country: "Gâmbia", code: "+220", iso2: "GM", iso3: "GMB", flag: flag_gm },
  gn: { country: "Guiné", code: "+224", iso2: "GN", iso3: "GIN", flag: flag_gn },
  gp: { country: "Guadalupe", code: "+590", iso2: "GP", iso3: "GLP", flag: flag_gp },
  gq: { country: "Guiné Equatorial", code: "+240", iso2: "GQ", iso3: "GNQ", flag: flag_gq },
  gr: { country: "Grécia", code: "+30", iso2: "GR", iso3: "GRC", flag: flag_gr },
  gs: { country: "Ilhas Geórgia do Sul", code: "+44", iso2: "GS", iso3: "SGS", flag: flag_gs },
  gt: { country: "Guatemala", code: "+502", iso2: "GT", iso3: "GTM", flag: flag_gt },
  gu: { country: "Guam", code: "+1671", iso2: "GU", iso3: "GUM", flag: flag_gu },
  gw: { country: "Guiné-Bissau", code: "+245", iso2: "GW", iso3: "GNB", flag: flag_gw },
  gy: { country: "Guiana", code: "+592", iso2: "GY", iso3: "GUY", flag: flag_gy },
  hk: { country: "Hong Kong", code: "+852", iso2: "HK", iso3: "HKG", flag: flag_hk },
  hm: {
    country: "Ilhas Heard e Ilhas MacDonald",
    code: "+61",
    iso2: "HM",
    iso3: "HMD",
    flag: flag_hm,
  },
  hn: { country: "Honduras", code: "+504", iso2: "HN", iso3: "HND", flag: flag_hn },
  hr: { country: "Croácia", code: "+385", iso2: "HR", iso3: "HRV", flag: flag_hr },
  ht: { country: "Haiti", code: "+509", iso2: "HT", iso3: "HTI", flag: flag_ht },
  hu: { country: "Hungria", code: "+36", iso2: "HU", iso3: "HUN", flag: flag_hu },
  id: { country: "Indonésia", code: "+62", iso2: "ID", iso3: "IDN", flag: flag_id },
  ie: { country: "Irlanda", code: "+353", iso2: "IE", iso3: "IRL", flag: flag_ie },
  il: { country: "Israel", code: "+972", iso2: "IL", iso3: "ISR", flag: flag_il },
  im: { country: "Ilha de Man", code: "+441624", iso2: "IM", iso3: "IMN", flag: flag_im },
  in: { country: "Índia", code: "+91", iso2: "IN", iso3: "IND", flag: flag_in },
  io: {
    country: "Território Britânico do Oceano Índico",
    code: "+246",
    iso2: "IO",
    iso3: "IOT",
    flag: flag_io,
  },
  iq: { country: "Iraque", code: "+964", iso2: "IQ", iso3: "IRQ", flag: flag_iq },
  ir: { country: "Irão", code: "+98", iso2: "IR", iso3: "IRN", flag: flag_ir },
  is: { country: "Islândia", code: "+354", iso2: "IS", iso3: "ISL", flag: flag_is },
  it: { country: "Itália", code: "+39", iso2: "IT", iso3: "ITA", flag: flag_it },
  je: { country: "Jersey", code: "+441534", iso2: "JE", iso3: "JEY", flag: flag_je },
  jm: { country: "Jamaica", code: "+1876", iso2: "JM", iso3: "JAM", flag: flag_jm },
  jo: { country: "Jordânia", code: "+962", iso2: "JO", iso3: "JOR", flag: flag_jo },
  jp: { country: "Japão", code: "+81", iso2: "JP", iso3: "JPN", flag: flag_jp },
  ke: { country: "Quénia", code: "+254", iso2: "KE", iso3: "KEN", flag: flag_ke },
  kg: { country: "Quirguistão", code: "+996", iso2: "KG", iso3: "KGZ", flag: flag_kg },
  kh: { country: "Camboja", code: "+855", iso2: "KH", iso3: "KHM", flag: flag_kh },
  ki: { country: "Kiribati", code: "+686", iso2: "KI", iso3: "KIR", flag: flag_ki },
  km: { country: "Comores", code: "+269", iso2: "KM", iso3: "COM", flag: flag_km },
  kn: { country: "São Cristóvão e Névis", code: "+1869", iso2: "KN", iso3: "KNA", flag: flag_kn },
  kp: { country: "Coreia do Norte", code: "+850", iso2: "KP", iso3: "PRK", flag: flag_kp },
  kr: { country: "Coreia do Sul", code: "+82", iso2: "KR", iso3: "KOR", flag: flag_kr },
  kw: { country: "Kuwait", code: "+965", iso2: "KW", iso3: "KWT", flag: flag_kw },
  ky: { country: "Ilhas Caimão", code: "+1345", iso2: "KY", iso3: "CYM", flag: flag_ky },
  kz: { country: "Cazaquistão", code: "+7", iso2: "KZ", iso3: "KAZ", flag: flag_kz },
  la: { country: "Laos", code: "+856", iso2: "LA", iso3: "LAO", flag: flag_la },
  lb: { country: "Líbano", code: "+961", iso2: "LB", iso3: "LBN", flag: flag_lb },
  lc: { country: "Santa Lúcia", code: "+1758", iso2: "LC", iso3: "LCA", flag: flag_lc },
  li: { country: "Liechtenstein", code: "+423", iso2: "LI", iso3: "LIE", flag: flag_li },
  lk: { country: "Sri Lanka", code: "+94", iso2: "LK", iso3: "LKA", flag: flag_lk },
  lr: { country: "Libéria", code: "+231", iso2: "LR", iso3: "LBR", flag: flag_lr },
  ls: { country: "Lesoto", code: "+266", iso2: "LS", iso3: "LSO", flag: flag_ls },
  lt: { country: "Lituânia", code: "+370", iso2: "LT", iso3: "LTU", flag: flag_lt },
  lu: { country: "Luxemburgo", code: "+352", iso2: "LU", iso3: "LUX", flag: flag_lu },
  lv: { country: "Letónia", code: "+371", iso2: "LV", iso3: "LVA", flag: flag_lv },
  ly: { country: "Líbia", code: "+218", iso2: "LY", iso3: "LBY", flag: flag_ly },
  ma: { country: "Marrocos", code: "+212", iso2: "MA", iso3: "MAR", flag: flag_ma },
  mc: { country: "Mónaco", code: "+377", iso2: "MC", iso3: "MCO", flag: flag_mc },
  md: { country: "Moldávia", code: "+373", iso2: "MD", iso3: "MDA", flag: flag_md },
  me: { country: "Montenegro", code: "+382", iso2: "ME", iso3: "MNE", flag: flag_me },
  mf: { country: "Saint Martin", code: "+1721", iso2: "MF", iso3: "MAF", flag: flag_mf },
  mg: { country: "Madagáscar", code: "+261", iso2: "MG", iso3: "MDG", flag: flag_mg },
  mh: { country: "Ilhas Marshall", code: "+692", iso2: "MH", iso3: "MHL", flag: flag_mh },
  mk: { country: "Macedónia", code: "+389", iso2: "MK", iso3: "MKD", flag: flag_mk },
  ml: { country: "Mali", code: "+223", iso2: "ML", iso3: "MLI", flag: flag_ml },
  mm: { country: "Myanmar", code: "+95", iso2: "MM", iso3: "MMR", flag: flag_mm },
  mn: { country: "Mongólia", code: "+976", iso2: "MN", iso3: "MNG", flag: flag_mn },
  mo: { country: "Macau", code: "+853", iso2: "MO", iso3: "MAC", flag: flag_mo },
  mp: { country: "Marianas Setentrionais", code: "+1670", iso2: "MP", iso3: "MNP", flag: flag_mp },
  mq: { country: "Martinica", code: "+596", iso2: "MQ", iso3: "MTQ", flag: flag_mq },
  mr: { country: "Mauritânia", code: "+222", iso2: "MR", iso3: "MRT", flag: flag_mr },
  ms: { country: "Montserrat", code: "+1664", iso2: "MS", iso3: "MSR", flag: flag_ms },
  mt: { country: "Malta", code: "+356", iso2: "MT", iso3: "MLT", flag: flag_mt },
  mu: { country: "Ilhas Maurícias", code: "+230", iso2: "MU", iso3: "MUS", flag: flag_mu },
  mv: { country: "Maldivas", code: "+960", iso2: "MV", iso3: "MDV", flag: flag_mv },
  mw: { country: "Malawi", code: "+265", iso2: "MW", iso3: "MWI", flag: flag_mw },
  mx: { country: "México", code: "+52", iso2: "MX", iso3: "MEX", flag: flag_mx },
  my: { country: "Malásia", code: "+60", iso2: "MY", iso3: "MYS", flag: flag_my },
  mz: { country: "Moçambique", code: "+258", iso2: "MZ", iso3: "MOZ", flag: flag_mz },
  na: { country: "Namíbia", code: "+264", iso2: "NA", iso3: "NAM", flag: flag_na },
  nc: { country: "Nova Caledónia", code: "+687", iso2: "NC", iso3: "NCL", flag: flag_nc },
  ne: { country: "Nigér", code: "+227", iso2: "NE", iso3: "NER", flag: flag_ne },
  nf: { country: "Ilha Norfolk", code: "+6723", iso2: "NF", iso3: "NFK", flag: flag_nf },
  ng: { country: "Nigéria", code: "+234", iso2: "NG", iso3: "NGA", flag: flag_ng },
  ni: { country: "Nicarágua", code: "+505", iso2: "NI", iso3: "NIC", flag: flag_ni },
  nl: { country: "Holanda", code: "+31", iso2: "NL", iso3: "NLD", flag: flag_nl },
  no: { country: "Noruega", code: "+47", iso2: "NO", iso3: "NOR", flag: flag_no },
  np: { country: "Nepal", code: "+977", iso2: "NP", iso3: "NPL", flag: flag_np },
  nr: { country: "Nauru", code: "+674", iso2: "NR", iso3: "NRU", flag: flag_nr },
  nu: { country: "Niue", code: "+683", iso2: "NU", iso3: "NIU", flag: flag_nu },
  nz: { country: "Nova Zelândia", code: "+64", iso2: "NZ", iso3: "NZL", flag: flag_nz },
  om: { country: "Omã", code: "+968", iso2: "OM", iso3: "OMN", flag: flag_om },
  pa: { country: "Panamá", code: "+507", iso2: "PA", iso3: "PAN", flag: flag_pa },
  pe: { country: "Peru", code: "+51", iso2: "PE", iso3: "PER", flag: flag_pe },
  pf: { country: "Polinésia Francesa", code: "+689", iso2: "PF", iso3: "PYF", flag: flag_pf },
  pg: { country: "Papua-Nova Guiné", code: "+675", iso2: "PG", iso3: "PNG", flag: flag_pg },
  ph: { country: "Filipinas", code: "+63", iso2: "PH", iso3: "PHL", flag: flag_ph },
  pk: { country: "Paquistão", code: "+92", iso2: "PK", iso3: "PAK", flag: flag_pk },
  pl: { country: "Polónia", code: "+48", iso2: "PL", iso3: "POL", flag: flag_pl },
  pm: { country: "São Pedro e Miquelão", code: "+508", iso2: "PM", iso3: "SPM", flag: flag_pm },
  pn: { country: "Pitcairn", code: "+649", iso2: "PN", iso3: "PCN", flag: flag_pn },
  pr: { country: "Porto Rico", code: "+1787", iso2: "PR", iso3: "PRI", flag: flag_pr },
  ps: { country: "Palestina", code: "+970", iso2: "PS", iso3: "PSE", flag: flag_ps },
  pt: { country: "Portugal", code: "+351", iso2: "PT", iso3: "PRT", flag: flag_pt },
  pw: { country: "Palau", code: "+680", iso2: "PW", iso3: "PLW", flag: flag_pw },
  py: { country: "Paraguai", code: "+595", iso2: "PY", iso3: "PRY", flag: flag_py },
  qa: { country: "Qatar", code: "+974", iso2: "QA", iso3: "QAT", flag: flag_qa },
  re: { country: "Reunião", code: "+262", iso2: "RE", iso3: "REU", flag: flag_re },
  ro: { country: "Roménia", code: "+40", iso2: "RO", iso3: "ROU", flag: flag_ro },
  rs: { country: "Sérvia", code: "+381", iso2: "RS", iso3: "SRB", flag: flag_rs },
  ru: { country: "Rússia", code: "+7", iso2: "RU", iso3: "RUS", flag: flag_ru },
  rw: { country: "Ruanda", code: "+250", iso2: "RW", iso3: "RWA", flag: flag_rw },
  sa: { country: "Arábia Saudita", code: "+966", iso2: "SA", iso3: "SAU", flag: flag_sa },
  sb: { country: "Ilhas Salomão", code: "+677", iso2: "SB", iso3: "SLB", flag: flag_sb },
  sc: { country: "Seychelles", code: "+248", iso2: "SC", iso3: "SYC", flag: flag_sc },
  sd: { country: "Sudão", code: "+249", iso2: "SD", iso3: "SDN", flag: flag_sd },
  se: { country: "Suécia", code: "+46", iso2: "SE", iso3: "SWE", flag: flag_se },
  sg: { country: "Singapura", code: "+65", iso2: "SG", iso3: "SGP", flag: flag_sg },
  sh: { country: "Santa Helena", code: "+290", iso2: "SH", iso3: "SHN", flag: flag_sh },
  si: { country: "Eslovenia", code: "+386", iso2: "SI", iso3: "SVN", flag: flag_si },
  sj: { country: "Svalbard", code: "+47", iso2: "SJ", iso3: "SJM", flag: flag_sj },
  sk: { country: "Eslováquia", code: "+421", iso2: "SK", iso3: "SVK", flag: flag_sk },
  sl: { country: "Serra Leoa", code: "+232", iso2: "SL", iso3: "SLE", flag: flag_sl },
  sm: { country: "San Marino", code: "+378", iso2: "SM", iso3: "SMR", flag: flag_sm },
  sn: { country: "Senegal", code: "+221", iso2: "SN", iso3: "SEN", flag: flag_sn },
  so: { country: "Somália", code: "+252", iso2: "SO", iso3: "SOM", flag: flag_so },
  sr: { country: "Suriname", code: "+597", iso2: "SR", iso3: "SUR", flag: flag_sr },
  ss: { country: "Sudão do Sul", code: "+211", iso2: "SS", iso3: "SSD", flag: flag_ss },
  st: { country: "São Tomé e Príncipe", code: "+239", iso2: "ST", iso3: "STP", flag: flag_st },
  sv: { country: "El Salvador", code: "+503", iso2: "SV", iso3: "SLV", flag: flag_sv },
  sx: { country: "Sint Maarten", code: "+1721", iso2: "SX", iso3: "SXM", flag: flag_sx },
  sy: { country: "Síria", code: "+963", iso2: "SY", iso3: "SYR", flag: flag_sy },
  sz: { country: "Suazilândia", code: "+268", iso2: "SZ", iso3: "SWZ", flag: flag_sz },
  tc: { country: "Turcas e Caicos", code: "+1649", iso2: "TC", iso3: "TCA", flag: flag_tc },
  td: { country: "Chade", code: "+235", iso2: "TD", iso3: "TCD", flag: flag_td },
  tf: {
    country: "Terras Austrais e Antárticas Francesas",
    code: "+33",
    iso2: "TF",
    iso3: "ATF",
    flag: flag_tf,
  },
  tg: { country: "Togo", code: "+228", iso2: "TG", iso3: "TGO", flag: flag_tg },
  th: { country: "Tailândia", code: "+66", iso2: "TH", iso3: "THA", flag: flag_th },
  tj: { country: "Tadjiquistão", code: "+992", iso2: "TJ", iso3: "TJK", flag: flag_tj },
  tk: { country: "Toquelau", code: "+690", iso2: "TK", iso3: "TKL", flag: flag_tk },
  tl: { country: "Timor Leste", code: "+670", iso2: "TL", iso3: "TLS", flag: flag_tl },
  tm: { country: "Turquemenistão", code: "+993", iso2: "TM", iso3: "TKM", flag: flag_tm },
  tn: { country: "Tunísia", code: "+216", iso2: "TN", iso3: "TUN", flag: flag_tn },
  to: { country: "Tonga", code: "+676", iso2: "TO", iso3: "TON", flag: flag_to },
  tr: { country: "Turquia", code: "+90", iso2: "TR", iso3: "TUR", flag: flag_tr },
  tt: { country: "Trinidad e Tobago", code: "+1868", iso2: "TT", iso3: "TTO", flag: flag_tt },
  tv: { country: "Tuvalu", code: "+688", iso2: "TV", iso3: "TUV", flag: flag_tv },
  tw: { country: "Taiwan", code: "+886", iso2: "TW", iso3: "TWN", flag: flag_tw },
  tz: { country: "Tanzânia", code: "+255", iso2: "TZ", iso3: "TZA", flag: flag_tz },
  ua: { country: "Ucrânia", code: "+380", iso2: "UA", iso3: "UKR", flag: flag_ua },
  ug: { country: "Uganda", code: "+256", iso2: "UG", iso3: "UGA", flag: flag_ug },
  um: {
    country: "Ilhas Menores Distantes dos Estados Unidos",
    code: "+246",
    iso2: "UM",
    iso3: "UMI",
    flag: flag_um,
  },
  us: { country: "Estados Unidos", code: "+1", iso2: "US", iso3: "USA", flag: flag_us },
  uy: { country: "Uruguai", code: "+598", iso2: "UY", iso3: "URY", flag: flag_uy },
  uz: { country: "Uzbequistão", code: "+998", iso2: "UZ", iso3: "UZB", flag: flag_uz },
  va: { country: "Vaticano", code: "+379", iso2: "VA", iso3: "VAT", flag: flag_va },
  vc: {
    country: "São Vicente e Granadinas",
    code: "+1784",
    iso2: "VC",
    iso3: "VCT",
    flag: flag_vc,
  },
  ve: { country: "Venezuela", code: "+58", iso2: "VE", iso3: "VEN", flag: flag_ve },
  vg: {
    country: "Ilhas Virgens Britânicas",
    code: "+1284",
    iso2: "VG",
    iso3: "VGB",
    flag: flag_vg,
  },
  vi: {
    country: "Ilhas Virgens Americanas",
    code: "+1340",
    iso2: "VI",
    iso3: "VIR",
    flag: flag_vi,
  },
  vn: { country: "Vietname", code: "+84", iso2: "VN", iso3: "VNM", flag: flag_vn },
  vu: { country: "Vanuatu", code: "+678", iso2: "VU", iso3: "VUT", flag: flag_vu },
  wf: { country: "Wallis e Futuna", code: "+681", iso2: "WF", iso3: "WLF", flag: flag_wf },
  ws: { country: "Samoa", code: "+685", iso2: "WS", iso3: "WSM", flag: flag_ws },
  xk: { country: "Kosovo", code: "+383", iso2: "XK", iso3: "KOS", flag: flag_xk },
  ye: { country: "Iémen", code: "+967", iso2: "YE", iso3: "YEM", flag: flag_ye },
  yt: { country: "Mayotte", code: "+269", iso2: "YT", iso3: "MYT", flag: flag_yt },
  za: { country: "África do Sul", code: "+27", iso2: "ZA", iso3: "ZAF", flag: flag_za },
  zm: { country: "Zâmbia", code: "+260", iso2: "ZM", iso3: "ZMB", flag: flag_zm },
  zw: { country: "Zimbabué", code: "+263", iso2: "ZW", iso3: "ZWE", flag: flag_zw },
} as const;

export type TMGFlagCountryKey = keyof typeof mgFlagsCountries;
